import { useEffect, useRef } from "react";
import { EntityVideoJS } from "./entity";
import { DME, useDevice } from "dmeditor";

import videojs from "video.js";
import "videojs-youtube";
import { config } from "./config";

const defaultOptions = {
  responsive: true,
  controls: true,
  playsinline: true,
  preload: "auto",
  fluid: true,
};

export const VideoJs = (props: DME.WidgetRenderProps<EntityVideoJS>) => {
  const { data, style } = props.blockNode;

  const videoRef = useRef(null);
  const playerRef = useRef<any>(null);

  const getTypeSetUp = () => {
    const typeConfig = config.videoTypes.find(
      (item) => item.value === data.type || ""
    );
    const setupData = typeConfig?.setup(data.src);
    return setupData;
  };

  const theme = style?.["theme"] || "";

  useEffect(() => {
    if (videoRef.current) {
      const setupData = getTypeSetUp();

      const videoElement = videoRef.current;

      playerRef.current = videojs(
        videoElement,
        {
          ...defaultOptions,
          ...setupData,
        },
        () => {}
      );
    }
  }, [data.src, theme]);

  useEffect(() => {
    // const player = playerRef.current as any;

    return () => {
      // if (player && !player.isDisposed()) {
      //   player.dispose();
      //   playerRef.current = null;
      // }
    };
  }, []);

  return (
    <div key={data.src + theme}>
      <div data-vjs-player>
        <video
          ref={videoRef}
          className={
            "video-js vjs-big-play-centered " +
            (theme ? "vjs-theme-" + theme : "")
          }
        />
      </div>
    </div>
  );
};
